import { mapState } from 'vuex'
import { util } from '@didi/soda-common'
import { membershipLandingCk } from './trackEvent.js'
import { MEMBER_STATUS, PAGE_FROM } from './common/enumsUtil.js'
import { getPageFromParam } from '@/page/member/common/utils.js'

const { env } = util

export default {
  computed: {
    ...mapState(['membership']),
    /** ------------------------ 页面来源逻辑 ------------------------ */
    pageFrom() {
      const pageFromParam = getPageFromParam(this.params)
      if (['RideSidebar', 'SAAccount', 'rideside'].includes(pageFromParam)) {
        return PAGE_FROM.fromEmbed
      } else if (pageFromParam === 'bill') {
        return PAGE_FROM.fromBill
      } else if (['tab', 'C_Bottom_Nav_A_1_0', 'C_Bottom_Nav_B_1_0'].includes(pageFromParam)) {
        return PAGE_FROM.fromTab
      } else if (pageFromParam === 'Rpage') {
        return PAGE_FROM.fromShop
      } else if (pageFromParam === 'RideSidebar') {
        return PAGE_FROM.fromEmbedSidebar
      }
    },
    // 是不是Android
    isAndroid() {
      return env.isAndroid
    },
    // 嵌入端
    isFromEmbed() {
      return this.pageFrom === PAGE_FROM.fromEmbed
    },
    // 提单页
    isFromBill() {
      return this.pageFrom === PAGE_FROM.fromBill
    },
    // 底导
    isFromTab() {
      return this.pageFrom === PAGE_FROM.fromTab
    },
    // 商家页
    isFromShop() {
      return this.pageFrom === PAGE_FROM.fromShop
    },
    // 出行侧边栏进入
    isFromEmbedSidebar() {
      return this.pageFrom === PAGE_FROM.fromEmbedSidebar
    },
    /** ------------------------ 用户状态 ------------------------ */
    memberStatus() {
      let status = ''
      if (this.membership?.isNewUser) {
        // 会员新客(从未获得过会员的用户)
        status = MEMBER_STATUS.newNoBuy
      } else if (this.membership?.status === 1 && this.membership?.subscriptionStatus === 1) {
        // 会员老客-未开通&未订阅
        status = MEMBER_STATUS.oldNoBuyNoSubscription
      } else if (this.membership?.status === 1 && this.membership?.subscriptionStatus === 2) {
        // 会员老客-未开通&已订阅
        status = MEMBER_STATUS.oldNoBuySubscription
      } else if (this.membership?.status === 1 && this.membership?.subscriptionStatus === 3) {
        // 会员老客-未开通&暂停订阅
        status = MEMBER_STATUS.oldNoBuyPaused
      } else if (this.membership?.status === 2 && this.membership?.subscriptionStatus === 2) {
        // 会员老客-已开通&已订阅
        status = MEMBER_STATUS.oldBuySubscription
      } else if (this.membership?.status === 2 && this.membership?.subscriptionStatus === 1) {
        // 会员老客-已开通&未订阅
        status = MEMBER_STATUS.oldBuyNoSubscription
      } else if (this.membership?.status === 2 && this.membership?.subscriptionStatus === 3) {
        // 会员老客-已开通&暂停订阅
        status = MEMBER_STATUS.oldBuyPaused
      }
      return status
    },
    isNewUserStatus() {
      return this.memberStatus === MEMBER_STATUS.newNoBuy
    },
    isPauseStatus() {
      // 会员老客-未开通&暂停订阅 || 会员老客-已开通&暂停订阅
      return (
        this.memberStatus === MEMBER_STATUS.oldNoBuyPaused ||
        this.memberStatus === MEMBER_STATUS.oldBuyPaused
      )
    },
    isBuySubscriptionStatus() {
      return this.memberStatus === MEMBER_STATUS.oldBuySubscription
    },
    isNoBuySubscriptionStatus() {
      return this.memberStatus === MEMBER_STATUS.oldNoBuySubscription
    },
    isSubscriptionPauseStatus() {
      return (
        this.memberStatus === MEMBER_STATUS.oldNoBuyPaused ||
        this.memberStatus === MEMBER_STATUS.oldBuySubscription
      )
    },
    isChangePaymentMixin() {
      return (
        this.memberStatus === MEMBER_STATUS.oldNoBuyPaused ||
        this.memberStatus === MEMBER_STATUS.oldBuySubscription ||
        this.memberStatus === MEMBER_STATUS.oldBuyPaused
      )
    },
    isNoBuyStatus() {
      return [
        MEMBER_STATUS.newNoBuy,
        MEMBER_STATUS.oldNoBuyNoSubscription,
        MEMBER_STATUS.oldNoBuySubscription,
        MEMBER_STATUS.oldNoBuyPaused,
      ].includes(this.memberStatus)
    },
    isBuyPauseStatus() {
      return this.memberStatus === MEMBER_STATUS.oldBuyPaused
    },
    isBuyNoSubscriptionStatus() {
      return this.memberStatus === MEMBER_STATUS.oldBuyNoSubscription
    },
    // pack->升级clue,特殊状态
    isUpgradesProStatus() {
      return this.membership?.status === 3
    },

    /** ------------------------ 埋点用户状态 ------------------------ */
    // 会员用户状态 0：未开通 - 已/未订阅； 1：已开通-且订阅；2:已开通-未订阅 3:会员锁定状态 4:未开通-订阅暂停 5: 已开通-订阅暂停 6: 新用户
    couponPackageStatus() {
      // lockStatus=2 的时候为锁定状态
      if (+this.membership?.lockStatus === 2) {
        return 3
      }
      if (this.membership?.status === 1) {
        if (this.membership?.isNewUser) {
          return 6
        } else if (this.membership?.subscriptionStatus === 3) {
          return 4
        } else {
          return 0
        }
      } else {
        // 订阅状态：1-未订阅  2-已订阅 3-订阅暂停
        if (this.membership?.subscriptionStatus === 3) {
          return 5
        } else if (this.membership?.subscriptionStatus === 2) {
          return 1
        } else {
          return 2
        }
      }
    },

    /** ------------------------ 通用状态 ------------------------ */
    brandName() {
      return this.membership?.brandName
    },
    /** ------------------------ 实验开关 ------------------------ */
    isGlobaloneStyle() {
      return this.membership?.testConfig?.memberGlobalOne > 1 // 大于1 命中实验组采用新样式
    },
    // 平铺模式
    isBenefitFlatMode() {
      return [2, 4].includes(this.membership?.testConfig?.memberGlobalOne)
    },
  },
  methods: {
    /** ------------------------ 点击埋点 ------------------------ */
    membershipLandingCkFn(click_type) {
      membershipLandingCk({
        coupon_package_status: this.couponPackageStatus,
        benefit_id: this.membership?.benefitID,
        click_type,
        benefit_type: +this.membership?.status,
        add_coupon_list: null,
        from: getPageFromParam(this.params),
      })
    },
  },
}
